module.exports = __webpack_public_path__ + "assets/normal/images/reset-permission-jp.3f91165b.png";